import React from 'react';

function RightBar() {

    return (
        <div className='righty' >
            <p>What's Alive?</p>
            <p>John Conway created a simple, yet powerful alogrithm that was essentially the birth of Artificial Intelligence.</p>
            <p>It proved that a computer could create, reproduce, and die all while having unpredictable results. Essentially thinking for itself.</p>
            <p>Rules of Alogrithm:</p>
            <p>1. A cell has two states in every generation, dead or alive.</p>
            <p>2. A cell dies with less than 2 or more than 3 neighbors</p>
            <p>3. A cell comes alive with 3 neighbors</p>
        
        </div>
    )
};



export default RightBar;